import React,{useState,useEffect} from "react";
import { Col } from "react-bootstrap";
import { useUI } from "../../../contexts/UIContext";
import Uploader from "./FileUploader";
import LinkUploader from "./LinkUploader";
import SynthesiaSettings from "./synthesiaSettings/SynthesiaSettings";
import Services from "./Services";
import ViewThreadFiles from "./ViewThreadFiles";
import PptTemplates from "./PptTemplates";
import ImageSettings from "./ImageSettings/ImageSettings";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import * as Sentry from "@sentry/react";
import { darkTheme_bg_color, fileUploader_bg_color_for_dm } from "../../../constants/colors";
import { useMediaQuery } from "@mui/material";

const SettingContent = () => {
  const { currentTheme } = useUI();
  const [theme,setTheme] = useState(localStorage.getItem('theme'));
  const {currentThread,threadFiles} = useWorkspace() ;
  const [currThreadLen,setCurrThreadLen] = useState(0);
  const isBelow1500 = useMediaQuery('(max-width:1500px)');

  useEffect(() => {
    setCurrThreadLen(currentThread.length);
  }, [currentThread])
  

  const getSettingBarStyle = (theme) => {
    return theme === "dark"
      ? { backgroundColor: darkTheme_bg_color , color: "white" }
      : { backgroundColor: "var(--bs-gray-300)", color: "black" };
  };

  return (
    <div
      style={{
        width:'282px',
        height: '100vh',
        overflowY: "auto",
        display: "inline-block",
        ...getSettingBarStyle(currentTheme),
        padding: '20px'
      }}
    >
      <Col className="py-3">
        <Sentry.ErrorBoundary fallback={<div>Something went wrong in the workspace</div>}>
        <div
          style={{
            height: '281px',
            width:'242px',
            border: '2px dotted',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor:theme === 'dark'?fileUploader_bg_color_for_dm:'',
          }}
        >
          <Uploader />
        </div>
        </Sentry.ErrorBoundary>
        
        <div className="mb-3" />
        <div 
        style={{
            border: '2px dotted',
            borderRadius: '10px',
            backgroundColor:theme === 'dark'?fileUploader_bg_color_for_dm:''
        }}>
          <LinkUploader />
        </div>
        <hr style={{marginTop:'28px'}}></hr>
        <div>
          <ViewThreadFiles />
        </div>
        
        {/* <hr style={{ margin: "10px 0", borderTop: "2px solid black" }} /> */}
        {/* <ViewThreadFiles />
        <hr style={{ margin: "10px 0", borderTop: "2px solid black" }} />
        <SynthesiaSettings />
        <hr style={{ margin: "10px 0", borderTop: "2px solid black" }} />
        <ImageSettings />
        <PptTemplates />
        {currThreadLen > 0 &&
        <div style={{ marginTop: '50px' }}>
          <Services />
        </div>
        } */}
        
      </Col>
    </div>
  );
};

export default SettingContent;



// import React from "react";
// import { Col } from "react-bootstrap";
// import { useUI } from "../../../contexts/UIContext";
// import Uploader from "./FileUploader";
// import LinkUploader from "./LinkUploader";
// import SynthesiaSettings from "./synthesiaSettings/SynthesiaSettings";
// import Services from "./Services";
// import ViewThreadFiles from "./ViewThreadFiles";

// const SettingContent = () => {
//   const { currentTheme } = useUI();

//   const getSettingBarStyle = (theme) => {
//     return theme === "dark"
//       ? { backgroundColor: "var(--bs-gray-dark)", color: "white" }
//       : { backgroundColor: "var(--bs-gray-300)", color: "black" };
//   };

//   return (
//     <Col
//       style={{
//         maxWidth: "300px",
//         minWidth: "300px",
//         overflowY: "auto",
//         height:'100vh',
//         display: "flex",
//         flexDirection: "column",
//         ...getSettingBarStyle(currentTheme),
//         padding:'20px'
//       }}
//       className="py-3"
//     >
//       <Uploader />
//       <div className="mb-3" />
//       <LinkUploader />
//       <hr style={{ margin: "10px 0", borderTop: "2px solid black" }} />
//       <ViewThreadFiles />
//       <hr style={{ margin: "10px 0", borderTop: "2px solid black" }} />
//       <SynthesiaSettings />
//       <div style={{marginTop:'50px'}}>
//         <Services />
//       </div>
//     </Col>
//   );
// };

// export default SettingContent;
